import React, { useCallback } from 'react';
import {
	Checkbox,
	Header,
	Popup
} from 'semantic-ui-react';

import { useUIAction, useUIState } from '../../contexts/UIContext';

import TextButton from '../Shared/TextButton';

const SupportModal = () => {
	const { showHelp } = useUIState();
	const { setShowHelp } = useUIAction();

	const handleToggle = useCallback( () => {
		setShowHelp( !showHelp );
	}, [ setShowHelp, showHelp ] );

	return (
		<Popup
			content={
				<>
					<Header>Contact Support</Header>
					<p>Here you are able to view the&nbsp;
						<a
							href="https://progmentum-docs.netlify.app/docs"
							target="blank"
							rel="noopener noreferrer"
						>
							documentation
						</a>
						&nbsp;or to open a&nbsp;
						<a
							href="https://progmentum-docs.netlify.app/support"
							target="blank"
							rel="noopener noreferrer"
						>
							support ticket.
						</a>
					</p>
					<br />
					<Checkbox
						checked={ showHelp }
						label="Show help?"
						onChange={ handleToggle }
						toggle
					/>
				</>
			}
			hoverable
			pointing
			trigger={ <TextButton buttonText="Support" /> }
		/>
	);
};

export default SupportModal;
